<template>
  <!-- Layout inner -->
  <div class="layout-inner explore explore_intro">
    <!-- Layout navbar -->
    <navbar></navbar>
    <!-- / Layout navbar -->

    <div class="layout-container">
      <div class="layout-content">

        <!-- Page content -->
        <div class="container-fluid flex-grow-1 pg_content_container">

          <div class="explore_entities">
            <div class="row explore_entities_inner">

              <div v-if="isExploreProgramsEnabled" class="col-sm-12 col-md-12 explore_entity_bx program">
                <div class="row card" style="background: #376573;">
                  <div class="col-8 card-body" @click="programResultsClicked">
                    <div class="row entity">
                      <div class="col-6 thumbnail_container">
                        <div class="ic ic-degreeProgram"></div>
                      </div>
                      <div class="col-6 entity_title">
                        Explore Programs
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isExploreCareersEnabled" class="col-sm-12 col-md-12 explore_entity_bx career">
                <div class="row card">
                  <div class="col-8 card-body" @click="careerResultsClicked">
                    <div class="row entity">
                      <div class="col-6 thumbnail_container">
                        <div class="ic ic-career"></div>
                      </div>
                      <div class="col-6 entity_title">
                        Explore Careers
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isExploreInsightsEnabled" class="col-sm-12 col-md-12 explore_entity_bx insight">
                <div class="row card">
                  <div class="col-8 card-body" @click="insightsResultsClicked">
                    <div class="row entity">
                      <div class="col-6 thumbnail_container">
                        <div class="ic ic-insight"></div>
                      </div>
                      <div class="col-6 entity_title">
                        Explore Insights
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import Navbar from '../../misc/components/./Navbar'

export default {
  name: 'exploreIntro',
  components: {
    Navbar
  },
  mounted () {
    this.loadExploreIntro()
  },
  methods: {
    ...mapActions([
      'loadUserObj',
      'loadInstitutionDetail',
      'loadInstitutionPackage',
      'resetCareerSearchState'
    ]),
    async loadExploreIntro () {
      await this.loadUserObj()
      await this.loadInstitutionPackage({uuid: this.institutionId, isAggregated: false})
    },
    programResultsClicked () {
      // this.resetProgramGuideSearchState()
      return this.$router.push({ name: 'exploreProgramResults' })
    },

    careerResultsClicked () {
      this.resetCareerSearchState()
      return this.$router.push({ name: 'exploreCareerResults' })
    },

    insightsResultsClicked () {
      return this.$router.push({ name: 'exploreInsightsResults' })
    }
  },
  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'enabledFeatures': state => state.dashboard.enabledFeatures
    }),
    institutionId () {
      return this.userObj.institutionId
    },
    isExploreProgramsEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    },
    isExploreCareersEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_CAREERS]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    },
    isExploreInsightsEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_INSIGHTS]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
  .report-tooltip-xaxis {
    top: 0px !important;
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreIntro.vue